<template>
  <a-flex vertical gap="middle" class="my-req-wrapper">
    <a-flex align="center" justify="space-between">
      <a-typography-text class="my-req-title">Мои обращения:</a-typography-text>

      <a-button
        @click="createRequest()"
        type="primary"
        class="icon-right"
        :disabled="isCreatingRequest"
        :icon="h(PlusOutlined)"
      >
        Новое обращение
      </a-button>
    </a-flex>

    <a-flex align="center" justify="end" gap="middle" v-if="canViewAll">
      <a-typography-text class="my-req-title">
        Показывать обращения всех сотрудников:
      </a-typography-text>
      <a-switch
        v-model:checked="supportUserStore.showAllRequests"
        @change="changeRequestsScope"
      />
    </a-flex>

    <SupportUserRequestsList />
  </a-flex>
</template>

<script setup lang="ts">
import { computed, h } from "vue";
import { useRoute, useRouter } from "vue-router";
import { PlusOutlined } from "@ant-design/icons-vue";
import SupportUserRequestsList from "@/components/settings/support/user/requests/SupportUserRequestsList.vue";
import { useUser } from "@/stores/user/user";
import { useSupportUserStore } from "@/stores/support/support-user.store";
import { debounce } from "@/tools/debounce";

const route = useRoute();
const router = useRouter();

const userStore = useUser();
const supportUserStore = useSupportUserStore();

const isCreatingRequest = computed(
  () => route.name === "supportUserRequestCreate",
);

const canViewAll = computed(() => userStore.isUserOwner);

const changeRequestsScope = debounce(supportUserStore.fetchAllUserChats, 600);

const createRequest = () => {
  router.push({
    name: "supportUserRequestCreate",
  });
};
</script>

<style scoped lang="scss">
.my-req-wrapper {
  position: sticky;
  top: 0;
}

.my-req-title {
  font-size: 15px;
}

.icon-right {
  display: flex;
  align-items: center;
  justify-content: center;

  .anticon {
    order: 2;
    margin-left: 8px;
  }
}
</style>
